// バックエンドエラーを日本語メッセージに変換するユーティリティ
import errorCodes from "../config/error_code.json";

// NOTE: エラーコードJSONの構造に基づいた日本語メッセージマッピング
const japaneseMessages: Record<string, string> = {
  // sstf.common
  "sstf.common.userNotFound": "指定されたユーザーが見つかりません。",
  "sstf.common.resolveIdNotFound": "指定されたIDが見つかりません。",
  "sstf.common.invalidEmail": "指定されたメールアドレスが無効です。",
  "sstf.common.emailEmpty": "メールアドレスが空です。",
  "sstf.common.selfDeletionDenied": "自分自身を削除することはできません。",
  "sstf.common.permissionDenied": "権限がありません。",
  "sstf.common.userDuplicate": "指定されたユーザーIDに対して複数のデータが見つかりました。",

  // sstf.user
  "sstf.user.invalidIconImageUrl": "指定されたアイコン画像URLが無効です。",
  "sstf.user.invalidField": "指定されたフィールドが無効です。",

  // sstf.template
  "sstf.template.notFound": "指定されたテンプレートが見つかりません。",

  // sstf.workspace
  "sstf.workspace.notFound": "指定されたワークスペースが見つかりません。",
  "sstf.workspace.invalidWorkspaceId": "指定されたワークスペースIDが無効です。",
  "sstf.workspace.invalidName": "指定された名前が無効です。",
  "sstf.workspace.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.workspace.invalidIconImageUrl": "指定されたアイコン画像URLが無効です。",
  "sstf.workspace.invalidField": "指定されたフィールドが無効です。",
  "sstf.workspace.workspaceDuplicate": "指定されたワークスペースIDに対して複数のデータが見つかりました。",

  // sstf.workspaceUser
  "sstf.workspaceUser.notFound": "指定されたワークスペースユーザーが見つかりません。",
  "sstf.workspaceUser.invalidInvitationToken": "指定された招待トークンが無効です。",
  "sstf.workspaceUser.invalidWorkspaceUserId": "指定されたワークスペースユーザーIDが無効です。",
  "sstf.workspaceUser.invalidEmailAddress": "指定されたメールアドレスが無効です。",
  "sstf.workspaceUser.selfDeletionDenied": "自分自身を削除することはできません。",
  "sstf.workspaceUser.alreadyRegisterdEmailAddress": "指定されたメールアドレスは既に登録されています。",
  "sstf.workspaceUser.inviteAlreadyJoinedWorkspaceUser": "指定されたワークスペースユーザーは既に参加しています。",

  // sstf.project
  "sstf.project.notFound": "指定されたプロジェクトが見つかりません。",
  "sstf.project.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.project.invalidIconImageUrl": "指定されたアイコン画像URLが無効です。",
  "sstf.project.invalidField": "指定されたフィールドが無効です。",
  "sstf.project.projectDuplicate": "指定されたプロジェクトIDに対して複数のデータが見つかりました。",

  // sstf.projectAssignee
  "sstf.projectAssignee.notFound": "指定されたプロジェクト担当者が見つかりません。",
  "sstf.projectAssignee.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.projectAssignee.selfDeletionDenied": "自分自身を削除することはできません。",

  // sstf.role
  "sstf.role.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.role.unabledUnsetOwnedAdminRole": "自分の管理者ロールを削除することはできません。",
  "sstf.role.unabledNotOnlyGuestRole": "ゲストロールと他のロールを同時に設定することはできません。",
  "sstf.role.roleInUse": "ロールの削除に失敗しました。このロールは現在使用中です。",

  // sstf.aggregation
  "sstf.aggregation.notFound": "指定された集計が見つかりません。",
  "sstf.aggregation.invalidArgument": "リクエストパラメータが無効です。",

  // sstf.testManagement
  "sstf.testManagement.notFound": "指定されたテストケースが見つかりません。",
  "sstf.testManagement.invalidArgument": "リクエストパラメータが無効です。",

  // sstf.scriptTestRun
  "sstf.scriptTestRun.notFound": "指定されたテスト結果が見つかりません。",
  "sstf.scriptTestRun.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.scriptTestRun.testRunExists": "テスト実行の作成時に既存のテスト実行が見つかりました。",
  "sstf.scriptTestRun.testRunCompleted": "完了したテスト実行に対して新しい結果を設定しようとしました。",

  // sstf.issue
  "sstf.issue.notFound": "指定された課題が見つかりません。",
  "sstf.issue.invalidArgument": "リクエストパラメータが無効です。",

  // sstf.testPlan
  "sstf.testPlan.notFound": "指定されたテスト計画が見つかりません。",
  "sstf.testPlan.invalidArgument": "リクエストパラメータが無効です。",

  // sstf.serviceIntegration
  "sstf.serviceIntegration.notFound": "指定されたサービス統合が見つかりません。",
  "sstf.serviceIntegration.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.serviceIntegration.connectionError": "外部サービスへの接続に失敗しました。",
  "sstf.serviceIntegration.attachmentsNumLimit": "ファイル数の上限を超えました。",
  "sstf.serviceIntegration.attachmentsFileError": "ファイルのアップロード中にエラーが発生しました。",
  "sstf.serviceIntegration.authIntegProjectImmutable": "認証設定の更新に失敗しました。関連する外部サービスプロジェクトの変更は許可されていません。",
  "sstf.serviceIntegration.cryptError": "暗号化キーエラーが発生しました。",

  // sstf.serviceIntegrationMapping
  "sstf.serviceIntegrationMapping.notFound": "指定されたサービス統合マッピングが見つかりません。",
  "sstf.serviceIntegrationMapping.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.serviceIntegrationMapping.connectionError": "外部サービスへの接続に失敗しました。",
  "sstf.serviceIntegrationMapping.cryptError": "暗号化キーエラーが発生しました。",

  // sstf.btsIssueSync
  "sstf.btsIssueSync.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.btsIssueSync.notFound": "指定されたBTS課題が見つかりません。",
  "sstf.btsIssueSync.btsIssueLinkDuplicate": "指定された課題IDに対して複数の課題リンクデータが見つかりました。",

  // sstf.testTarget
  "sstf.testTarget.notFound": "指定されたテストターゲットが見つかりません。",
  "sstf.testTarget.invalidArgument": "リクエストパラメータが無効です。",
  "sstf.testTarget.selfParentAssignment": "自分自身を親として設定することはできません。",
  "sstf.testTarget.invalidTreeStructure": "テストターゲットの階層構造が無効です。",
  "sstf.testTarget.duplicateNameAtSameLevel": "同じ階層に同じ名前のテストターゲットが既に存在します。",

  // sstf.uploadedFile
  "sstf.uploadedFile.notFound": "指定されたアップロードファイルが見つかりません。",
  "sstf.uploadedFile.invalidArgument": "リクエストパラメータが無効です。",
};

/** バックエンド（Streamlit）接続不可時にUIに表示するメッセージ */
export const BACKEND_UNAVAILABLE_MESSAGE =
  "サーバーに接続できません。ネットワークがつながっていることを確認の上、しばらく待ってから送信をお試しください。";

/** UIに表示するエラー詳細の最大文字数（スタックトレース等を出さないため） */
const MAX_USER_VISIBLE_DETAIL_LENGTH = 200;

/**
 * エラー詳細が技術的（スタックトレース・接続エラー等）かどうかを判定する
 * 技術的な場合はUIには表示せず、ユーザー向け案内に差し替える
 */
function is_technical_error_detail(detail: string | null): boolean {
  if (!detail || detail.length > MAX_USER_VISIBLE_DETAIL_LENGTH) {
    return true;
  }
  const lower = detail.toLowerCase();
  const technicalMarkers = [
    "traceback",
    "stack trace",
    "stack_trace",
    "getaddrinfo",
    "enotfound",
    "econnrefused",
    "graphql execution failed",
    "file \"",
    "file '",
    "transportconnectionfailed",
    "httpx.connecterror",
    "httpcore.connecterror",
  ];
  return technicalMarkers.some((m) => lower.includes(m));
}

/**
 * HTTPエラー用のユーザー向けメッセージを取得する
 * 5xxで技術的メッセージの場合は接続案内に統一し、4xxではBFFの日本語メッセージを試す
 * @param status - HTTPステータスコード
 * @param detail - formatErrorDetails で得た詳細文字列
 * @param responseData - response.data（BFFの errors 等を参照するため）
 */
export function get_user_facing_http_error_message(
  status: number,
  detail: string | null,
  responseData?: any
): string {
  const statusFamily = Math.floor(status / 100);

  // 5xx/4xx とも、BFFの errors がレスポンスに含まれていれば日本語メッセージを優先する
  // （バックエンドが 500 を返しても中身が sstf.testTarget.invalidArgument 等の場合はこちらで表示）
  if (responseData) {
    const fromBff = try_get_bff_error_message(responseData);
    if (fromBff) return fromBff;
  }
  // 詳細文字列に埋め込まれた domain/reason からも試す（500 で GraphQL エラーが文字列で返る場合）
  if (detail) {
    const fromDetail = try_get_bff_message_from_detail_string(detail);
    if (fromDetail) return fromDetail;
  }

  if (statusFamily === 5) {
    if (is_technical_error_detail(detail)) {
      return BACKEND_UNAVAILABLE_MESSAGE;
    }
    return detail!.length > MAX_USER_VISIBLE_DETAIL_LENGTH
      ? `${detail!.slice(0, MAX_USER_VISIBLE_DETAIL_LENGTH)}...`
      : detail!;
  }

  if (statusFamily === 4) {
    // BFF は上で試済み
  }

  if (detail && !is_technical_error_detail(detail)) {
    return detail.length > MAX_USER_VISIBLE_DETAIL_LENGTH
      ? `${detail.slice(0, MAX_USER_VISIBLE_DETAIL_LENGTH)}...`
      : detail;
  }

  if (status === 408) return "リクエストがタイムアウトしました。";
  if (status === 404) {
    return "要求したデータが見つかりません（HTTP 404）。サーバーからの説明文を取得できない場合があります。";
  }
  if (status === 403) return "権限がありません。";
  if (status === 401) return "認証が必要です。";

  return BACKEND_UNAVAILABLE_MESSAGE;
}

/**
 * レスポンスボディからBFFのエラーコードを取得し日本語メッセージに変換する
 */
function try_get_bff_error_message(responseData: any): string | null {
  if (!responseData || typeof responseData !== "object") return null;
  const errors = responseData.errors ?? responseData.api_data?.errors;
  if (!Array.isArray(errors) || errors.length === 0) return null;
  const first = errors[0];
  const codePath = extract_error_code_path(first);
  if (!codePath) return null;
  const ja = get_japanese_message(codePath);
  if (ja) return ja;
  const en = get_english_message_from_json(codePath);
  return en ?? null;
}

/**
 * 長いエラー詳細文字列に埋め込まれた BFF の domain/reason を抽出し日本語メッセージに変換する
 * （バックエンドが 500 で GraphQL エラー内容を文字列で返している場合のフォールバック）
 */
function try_get_bff_message_from_detail_string(detail: string | null): string | null {
  if (!detail || typeof detail !== "string") return null;
  // 'domain': 'sstf.testTarget', 'reason': 'invalidArgument' または "domain": "sstf.xxx" 形式を探す
  const domainMatch = detail.match(/'domain':\s*'([^']+)'/) || detail.match(/"domain":\s*"([^"]+)"/);
  const reasonMatch = detail.match(/'reason':\s*'([^']+)'/) || detail.match(/"reason":\s*"([^"]+)"/);
  if (!domainMatch || !reasonMatch) return null;
  const codePath = `${domainMatch[1]}.${reasonMatch[1]}`;
  const ja = get_japanese_message(codePath);
  if (ja) return ja;
  const en = get_english_message_from_json(codePath);
  return en ?? null;
}

/**
 * GraphQLエラーからエラーコードパスを抽出する
 * @param error - GraphQLエラーオブジェクト
 * @returns エラーコードパス（例: "sstf.testTarget.duplicateNameAtSameLevel"）
 */
function extract_error_code_path(error: any): string | null {
  if (!error || typeof error !== "object") {
    return null;
  }

  // GraphQLエラーのextensions.errorsから抽出
  if (error.extensions?.errors && Array.isArray(error.extensions.errors)) {
    const firstError = error.extensions.errors[0];
    if (firstError?.domain && firstError?.reason) {
      // domain: "sstf.testTarget" -> "sstf.testTarget"
      // reason: "duplicateNameAtSameLevel" -> "duplicateNameAtSameLevel"
      return `${firstError.domain}.${firstError.reason}`;
    }
  }

  // 直接domainとreasonが指定されている場合
  if (error.domain && error.reason) {
    return `${error.domain}.${error.reason}`;
  }

  return null;
}

/**
 * エラーコードパスから日本語メッセージを取得する
 * @param errorCodePath - エラーコードパス（例: "sstf.testTarget.duplicateNameAtSameLevel"）
 * @returns 日本語メッセージ、見つからない場合はnull
 */
function get_japanese_message(errorCodePath: string): string | null {
  return japaneseMessages[errorCodePath] || null;
}

/**
 * エラーコードJSONから英語メッセージを取得する
 * @param errorCodePath - エラーコードパス（例: "sstf.testTarget.duplicateNameAtSameLevel"）
 * @returns 英語メッセージ、見つからない場合はnull
 */
function get_english_message_from_json(errorCodePath: string): string | null {
  try {
    const parts = errorCodePath.split(".");
    if (parts.length < 3) {
      return null;
    }

    // "sstf.testTarget.duplicateNameAtSameLevel" -> ["sstf", "testTarget", "duplicateNameAtSameLevel"]
    const [sstf, domain, reason] = parts;
    if (sstf !== "sstf") {
      return null;
    }

    const errorCode = (errorCodes as any).sstf?.[domain]?.[reason];
    if (errorCode?.message) {
      return errorCode.message;
    }

    return null;
  } catch {
    return null;
  }
}

/**
 * GraphQLエラーを日本語メッセージに変換する
 * @param error - エラーオブジェクト（Error、GraphQLエラー、または文字列）
 * @returns ユーザーフレンドリーな日本語エラーメッセージ
 */
export function format_error_message(error: unknown): string {
  // 文字列の場合はそのまま返す
  if (typeof error === "string") {
    return error;
  }

  // Errorオブジェクトの場合
  if (error instanceof Error) {
    const errorMessage = error.message;

    // GraphQLエラーのJSON文字列をパース
    if (errorMessage.includes("GraphQL errors:")) {
      try {
        // "GraphQL errors: [...]" の形式から配列を抽出
        const jsonMatch = errorMessage.match(/GraphQL errors:\s*(.+)/);
        if (jsonMatch) {
          const errors = JSON.parse(jsonMatch[1]);
          if (Array.isArray(errors) && errors.length > 0) {
            const firstError = errors[0];
            const errorCodePath = extract_error_code_path(firstError);

            if (errorCodePath) {
              // 日本語メッセージを優先的に使用
              const japaneseMessage = get_japanese_message(errorCodePath);
              if (japaneseMessage) {
                return japaneseMessage;
              }

              // 日本語メッセージがない場合は、エラーコードJSONから英語メッセージを取得
              const englishMessage = get_english_message_from_json(errorCodePath);
              if (englishMessage) {
                return englishMessage;
              }
            }

            // extensions.errorsから直接メッセージを取得（優先度: 日本語 > 英語）
            if (firstError.extensions?.errors?.[0]) {
              const extensionError = firstError.extensions.errors[0];
              const extensionErrorCodePath = extract_error_code_path(extensionError);
              if (extensionErrorCodePath) {
                const japaneseMessage = get_japanese_message(extensionErrorCodePath);
                if (japaneseMessage) {
                  return japaneseMessage;
                }
              }
              if (extensionError.message) {
                return extensionError.message;
              }
            }

            // エラーメッセージをそのまま使用
            if (firstError.message) {
              return firstError.message;
            }
          }
        }
      } catch (parseError) {
        console.warn("エラーメッセージのパースに失敗しました:", parseError);
      }
    }

    // その他のエラーメッセージ
    return errorMessage;
  }

  // その他の型のエラー
  return "不明なエラーが発生しました。";
}

/**
 * エラーオブジェクトから簡潔なエラーメッセージを取得する
 * @param error - エラーオブジェクト
 * @param defaultMessage - デフォルトメッセージ
 * @returns 簡潔なエラーメッセージ
 */
export function get_simple_error_message(
  error: unknown,
  defaultMessage: string = "エラーが発生しました。"
): string {
  const formattedMessage = format_error_message(error);
  return formattedMessage || defaultMessage;
}

